import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgStore = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M13.0769 3.54717H10.5V2.38995C10.5 1.66422 9.69848 1 8.93486 1H7.09401C6.3304 1 5.5 1.66422 5.5 2.38995V3.54717H2.92308C2.41331 3.54717 2 3.93997 2 4.42444V14.5127C2 14.9971 2.41331 15.3899 2.92308 15.3899H13.0769C13.5867 15.3899 14 14.9971 14 14.5127V4.42444C14 3.93997 13.5867 3.54717 13.0769 3.54717ZM6.63248 2.70586C6.63248 2.46373 6.83925 2.26722 7.09401 2.26722H8.93486C9.18963 2.26722 9.3964 2.46373 9.3964 2.70586V3.54717H6.63248V2.70586ZM12.7195 14.0175H3.3886V4.78083H5.5V5.32694C5.5 5.32694 5.5 5.76512 6.06008 5.76512C6.62016 5.76512 6.63249 5.32694 6.63249 5.32694L6.63248 4.78083H9.3964L9.39641 5.32694C9.39641 5.32694 9.3964 5.76512 9.95023 5.76512C10.4504 5.76512 10.5 5.38995 10.5 5.38995V4.78083H12.7195V14.0175Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgStore)
const IconSvgStore = createIcon(ForwardRef, 'SvgStore')
export default IconSvgStore
